import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject, _templateObject2;

import { css, memoizeStyle } from "../../../../lib/theming/Emotion";
export var styles = memoizeStyle({
  root: function root() {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      display: inline-block;\n      margin-left: -0.0714285714285714em;\n      margin-right: -0.0714285714285714em;\n    "])));
  },
  icon: function icon() {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      height: 1.1428571428571428em;\n      width: 1.1428571428571428em;\n      margin-bottom: -0.1428571428571428em;\n    "])));
  }
});